import { Box, Typography } from "@mui/material";
import ArrowRightAltIcon from "@mui/icons-material/ArrowRightAlt";
import React from "react";
import { motion } from "framer-motion";

const courses = [1, 2, 3];
const MotionBox = motion(Box);
const MotionTypography = motion(Typography);

function Hero() {
  const gradientStyle = {
    background:
      "linear-gradient(to right, rgba(255, 255, 255, 1), rgba(255, 255, 255, 0.4))",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
  };
  return (
    <div className="App">
      {/* <Particles params={particlesConfig}/> */}
      <MotionBox
        sx={{
          flexGrow: 1,
          padding: 4,
          flexDirection: "column",
          // background: "linear-gradient(135deg, #f5f7fa, #c3cfe2)", // Light gradient for a fresh look
          background: "black",
          height: "90vh",
          justifyContent: "center",
          alignItems: "center",
          display: "flex",
          gap: "0.8rem",
          overflow: "hidden",
          position: "relative",
        }}
      >
        <MotionTypography
          fontSize={{ xs: "1.9rem", sm: "2.5rem", md: "4.3rem" }}
          sx={{
            fontWeight: "bold",
            color: "#333",
            textShadow: "1px 1px 2px rgba(0,0,0,0.1)", // Subtle text shadow
            textAlign: "center",
          }}
          initial={{ opacity: 0, scale: 0.5 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{
            duration: 0.8,
            delay: 0.5,
            ease: [0, 0.71, 0.2, 1.01],
          }}
          style={gradientStyle}
        >
          Unlock Your Career with Our Computer Courses
        </MotionTypography>
        <MotionTypography
          fontSize={{ xs: "0.9rem", sm: "1.5rem", md: "1.3rem" }}
          sx={{
            color: "white",
            lineHeight: 1.8,
            textAlign: "center",
            width: { xs: "100%", sm: "100%", md: "80%" },
          }}
          initial={{ opacity: 0, scale: 0.5 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{
            duration: 0.8,
            delay: 0.7,
            ease: [0, 0.71, 0.2, 1.01],
          }}
        >
          Join our community of learners and enhance your skills with our
          diverse range of computers courses designed for all ages. Enroll today
          and take the first step towards a brighter future!
        </MotionTypography>
        <MotionBox
          gap={2}
          initial={{ opacity: 0, scale: 0.5 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{
            duration: 0.8,
            delay: 1,
            ease: [0, 0.71, 0.2, 1.01],
          }}
        >
          <Box
            sx={{
              bgcolor: "hsla(0, 0%, 100%, 0.1)",
              borderRadius: 10,
              color: "black",
              textAlign: "center",
              alignContent: "center",
              alignItems: "center",
              paddingX: "1rem",
              borderColor: "hsla(0, 0%, 100%, 0.05)",
              borderWidth: "1px", // Equivalent to .border
              borderStyle: "solid", // Needed for applying the border width
            }}
          >
            <Typography
              style={{ "--shimmer-width": "100px" }}
              sx={{
                justifyContent: "center",
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                backgroundClip: "text",
                backgroundRepeat: "no-repeat",
                backgroundSize: "200% 100%", // To allow the shimmer to move across the text
                backgroundImage:
                  "linear-gradient(to right, #f5f5f5 20%, rgba(0, 0, 0, 0.8) 50%, #f5f5f5 80%)",
                color: "hsla(0,0%,64%,.5)", // Hide text color to reveal shimmer effect
                animation: "shimmer 5s infinite", // Apply the shimmer animation
                "@keyframes shimmer": {
                  "0%": { backgroundPosition: "200% 0" },
                  "100%": { backgroundPosition: "-200% 0" },
                },
              }}
            >
              <span>✨ Introducing our courses</span>
              <ArrowRightAltIcon
                className="shimmer-icon"
                sx={{
                  marginLeft: "0.25rem",
                  transition: "transform 0.3s ease-in-out",
                }}
              />
            </Typography>
          </Box>
        </MotionBox>
        <MotionBox
          initial={{
            boxShadow: "0 -22px 125px -45px rgba(255, 215, 0, 0.7)", // Initial golden shadow
          }}
          animate={{
            boxShadow: [
              "0 -22px 105px -45px rgba(255, 215, 0, 0.5)", // Softer shadow
              "0 -22px 125px -35px rgba(255, 215, 0, 0.9)", // Larger and brighter
              "0 -22px 105px -45px rgba(255, 215, 0, 0.7)", // Original state
            ],
            transition: {
              duration: 4, // Adjust for smoother animation
              ease: "easeInOut",
              repeat: Infinity,
              repeatType: "reverse",
            },
          }}
          sx={{
            width: "100%",
            boxShadow:
              "0 -22px 125px -45px rgba(255, 215, 0, 0.7)" /* Golden shadow */,
            height: "100%",
            borderRadius: "50%",
            position: "absolute",
            top: "100%",
            // margin:'100px auto',
            // background:'#1e1e1e'
          }}
        ></MotionBox>
      </MotionBox>
    </div>
  );
}

export default Hero;
